import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import '../../assets/styles/root.css'
import '../../assets/styles/tabletop.css'
import '../../assets/styles/icon.css'
import '../../assets/styles/worker.css'
import '../../assets/styles/queen.css'
import '../../assets/styles/board.css'
import '../../assets/styles/hive.css'
import '../../assets/styles/cell.css'
import '../../assets/styles/nesting.css'
import '../../assets/styles/app.css'
import '../../assets/styles/flower-market.css'
import '../../assets/styles/opponents-tableau.css'
import '../../assets/styles/log.css'
import '../../assets/styles/game-menu.css'
import '../../assets/styles/evolution-tree.css'
import '../../assets/styles/donation.css'
import '../../assets/styles/queen-trading.css'
import '../../assets/styles/colony-collapse-event.css'
import '../../assets/styles/game-end.css'
import '../../assets/styles/season-overview.css'
import '../../assets/styles/lobby.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
